import { Box, Stack } from '@mui/material';
import { AppliesContext } from 'Context/AppliesContext';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { ApplicationAccordion } from './ApplicationAccordion';
import { NoResults2, PaginationResult2 } from 'Components';
import { useParams } from 'react-router-dom';

const maxApplicationsPerPage = 8;

export const ApplicationDetailsList = () => {
  const { filteredApplications } = useContext(AppliesContext);
  const [pagination, setPagination] = useState<boolean>(true);
  const [expandedAccordionIndex, setExpandedAccordionIndex] = useState<
    number | null
  >(null);
  const restApplicationsRef = useRef<HTMLSpanElement>(null);

  const applyId = useParams().id;

  const getApplyById = useMemo(() => {
    return (
      applyId &&
      filteredApplications.find(
        (application) => application.shemeshApplyNumber === applyId
      )
    );
  }, [applyId, filteredApplications]);

  const getApplyByIdIndex = useMemo(() => {
    return applyId && getApplyById
      ? filteredApplications.findIndex(
          (application) => application.shemeshApplyNumber === applyId
        )
      : null;
  }, [applyId, filteredApplications, getApplyById]);

  useEffect(() => {
    if (getApplyByIdIndex !== null) {
      setExpandedAccordionIndex(getApplyByIdIndex);
    }
  }, [getApplyById, getApplyByIdIndex]);

  useEffect(() => {
    if (!pagination && restApplicationsRef?.current) {
      restApplicationsRef.current.focus();
    }
  }, [pagination]);

  useEffect(() => {
    if (filteredApplications.length <= maxApplicationsPerPage) {
      setPagination(false);
    } else {
      setPagination(true);
    }
  }, [filteredApplications.length]);

  const paginatedApplications =
    filteredApplications.length <= maxApplicationsPerPage
      ? filteredApplications
      : filteredApplications?.slice(0, maxApplicationsPerPage);

  const restApplications = filteredApplications?.slice(
    maxApplicationsPerPage,
    filteredApplications.length
  );

  return (
    <Stack padding={0} margin={0} gap={'24px'} component={'ul'}>
      {getApplyById && (
        <ApplicationAccordion apply={getApplyById} expanded={true} />
      )}
      {paginatedApplications.length > 0 &&
        paginatedApplications.map((application, index) =>
          index !== expandedAccordionIndex ? (
            <ApplicationAccordion key={index} apply={application} />
          ) : null
        )}
      {!pagination &&
        restApplications.length > 0 &&
        restApplications.map((application, index) =>
          index + maxApplicationsPerPage !== expandedAccordionIndex ? (
            <Box
              key={index}
              ref={index === 0 ? restApplicationsRef : undefined}
            >
              <ApplicationAccordion apply={application} />
            </Box>
          ) : null
        )}

      {!paginatedApplications.length && (
        <NoResults2
          textSearch={Dictionary[DICTIONARY.Applies].noResultsFilter}
        />
      )}

      {pagination && (
        <PaginationResult2
          text={Dictionary[DICTIONARY.Applies].earlierRequests}
          onClick={() => setPagination(false)}
        />
      )}
    </Stack>
  );
};
